module.exports = __webpack_public_path__ + "img/icons BFr_14.0d596db6.png";